module.exports = __webpack_public_path__ + "img/logo-UMUC-tmp.36e29299.svg";